import { render, staticRenderFns } from "./mappingData.vue?vue&type=template&id=550b5f33&scoped=true"
import script from "./mappingData.vue?vue&type=script&lang=js"
export * from "./mappingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b5f33",
  null
  
)

export default component.exports